<template>
  <div class="oblig-list">
    <h1>Obligatoriske oppgaver</h1>
    <div class="grid-container">
      <div
        class="module-list-items"
        v-for="(mod, splindex) in this.$store.state.mandatoryAssignments
          .modules"
        v-bind:key="splindex"
      >
        <h2>{{ mod.name }}</h2>

        <div class="module-card-container">
          <div
            class="module-cards"
            v-for="(oblig, index) in mod.assignments"
            v-bind:key="index"
          >
            <oblig-card :modul="mod.name" :obligs="oblig" :id="index" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ObligCard from "@/components/ObligCard";

export default {
  name: "ObligList",
  components: {
    ObligCard,
  },
};
</script>

<style lang="scss" scoped>
.grid-container {
  display: flex;
  flex-direction: column;
  grid-column-gap: 50px;
  grid-template-columns: auto auto auto;
}

.module-card-container {
  display: flex;
  flex-direction: row;
}

.module-cards {
  margin: 0 30px;
}

@media only screen and (max-width: 768px) {
  .module-card-container {
    padding: 0px;
    display: flex;
    flex-direction: column;
  }
  .module-cards {
    margin: 0;
  }
}
</style>